module.exports = __webpack_public_path__ + "static/img/cp3.4ec0c81f.png";